import { useLocation } from "wouter";
import {
  Text,
  Paper,
  Container,
  Title,
  Stack,
  TextInput,
  Group,
  Button,
  Divider,
} from "@mantine/core";
import { TwitterButton } from "./TwitterButton";
// import { RedditButton } from "./RedditButton";
import { GoogleButton } from "./GoogleButton";
import { useStore } from "../store";
import mixpanel from "mixpanel-browser";
import { useForm } from "@mantine/form";
import { useState } from "react";
import { notifications } from "@mantine/notifications";
import { requestLogin, loginWithToken } from "../api";

export default function AuthenticationForm(props) {
  const [, setLocation] = useLocation();
  const authToken = useStore((state) => state.authToken);
  const setAuthToken = useStore((state) => state.setAuthToken);

  function openWindow(url) {
    const width = 450;
    const height = 730;
    const left = window.screen.width / 2 - width / 2;
    const top = window.screen.height / 2 - height / 2;
    const bc = new BroadcastChannel("vortexauth");
    bc.onmessage = (event) => {
      // handle event.data posted from your popup
      // console.debug("event received", event);
      // console.debug("setting token:", event.data.token);
      setAuthToken(event.data.token);
      setLocation("/");
      mixpanel.track("Sign-In Succeeded");
    };
    window.open(
      url,
      "_blank",
      `popup,menubar=no,location=no,resizable=no,scrollbars=no,status=no, width=${width}, height=${height}, top=${top}, left=${left}`
    );
  }

  if (authToken) {
    return (
      <Container size="sm" mt="xl">
        <Paper radius="md" p="xl" withBorder {...props}>
          <Text size="lg" fw={500}>
            You are logged in
          </Text>
        </Paper>
      </Container>
    );
  }

  const [isFetching, setIsFetching] = useState(false);

  const form = useForm({
    mode: "uncontrolled",
    initialValues: {
      email: "",
    },
    validate: {
      email: (val) => (/^\S+@\S+$/.test(val) ? null : "Invalid email"),
    },
  });

  return (
    <Container size="sm" mt="xl">
      <Paper radius="md" p="xl" withBorder {...props}>
        <Title order={2}>Start taking pictures!</Title>
        {/* 
        <Text size="md" mt="xl" fw={500}>
          Choose a login method
        </Text> */}

        <Stack mb="md" mt="md">
          <GoogleButton
            type="submit"
            radius="xl"
            onClick={() => {
              openWindow("/api/auth/signin?provider=Google");
              mixpanel.track("Sign-In Requested", { Provider: "Google" });
            }}
          >
            Google
          </GoogleButton>

          <TwitterButton
            type="submit"
            radius="xl"
            disabled
            onClick={() => {
              openWindow("/api/auth/signin?provider=Twitter");
              mixpanel.track("Sign-In Requested", { Provider: "Twitter" });
            }}
          >
            X / Twitter
          </TwitterButton>

          <Divider orientation="horizontal" label="or" />

          <form
            onSubmit={form.onSubmit((values) => {
              setIsFetching(true);
              requestLogin({ ...values })
                .then(() => {
                  setIsFetching(false);
                  notifications.show({
                    title: "Email sent",
                    message: "Please follow the link in the email",
                    color: "green",
                    autoClose: false,
                  });
                })
                .catch((err) => {
                  setIsFetching(false);
                  notifications.show({
                    title: "An error occurred!",
                    message: "Sorry, something went wrong: " + err,
                    color: "red",
                    autoClose: false,
                  });
                });
            })}
          >
            <Group align="flex-start">
              <TextInput
                placeholder="Enter your email"
                style={{ flex: 1 }}
                {...form.getInputProps("email")}
                key={form.key("email")}
              />
              <Button loading={isFetching} variant="gradient" type="submit">
                Proceed
              </Button>
            </Group>
          </form>
        </Stack>
      </Paper>
    </Container>
  );
}
